<template>
  <div class="sac-product-card">

    <div class="sac-product-card__header">
      <h3 class="form-sec-title">{{ _e('sac_review_products') }}</h3>
      <button type="button" class="btn-edit" @click.stop="handleEdit">
        <span class="btn-edit__label">{{ _e('sac_edit_label') }}</span>
        <span class="btn-edit__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0605 2C16.4665 2 16.8586 2.14054 17.1699 2.39551L17.2979 2.51172L21.4873 6.69922C21.8152 7.02737 22 7.4726 22 7.93652C22 8.40045 21.8162 8.84568 21.4883 9.17383L18.7197 11.9424C18.7153 11.947 18.7116 11.9525 18.707 11.957C18.7025 11.9616 18.697 11.9653 18.6924 11.9697L11.4141 19.25H20.25C20.8022 19.25 21.2499 19.6978 21.25 20.25C21.25 20.8023 20.8023 21.25 20.25 21.25H4.5C4.03587 21.25 3.59089 21.0655 3.2627 20.7373C2.93454 20.4091 2.75 19.9641 2.75 19.5V15.3096L2.75879 15.1377C2.79855 14.7375 2.97509 14.3612 3.26172 14.0742L14.8242 2.51172C15.1523 2.18412 15.5969 2.00006 16.0605 2ZM4.75 15.4141V19.25H8.58594L16.584 11.248L12.75 7.41406L4.75 15.4141ZM14.1641 6L17.998 9.83398L19.8965 7.93555L16.0605 4.10254L14.1641 6Z" fill="currentColor"/></svg>
        </span>
      </button>
    </div>

    <div class="sac-product-card__body">
      <div class="sac-product-card__field col--wide col--md-6">
        <span class="sac-product-card__label">{{ _e('sac_produto_label') }}</span>
        <p class="sac-product-card__value">{{ productName }}</p>
      </div>
      <div class="sac-product-card__field col--wide col--md-6">
        <span class="sac-product-card__label">{{ _e('sac_peso_label') }}</span>
        <p class="sac-product-card__value">{{ props.model.peso }}</p>
      </div>

      <div class="sac-product-card__field col--wide col--md-6">
        <span class="sac-product-card__label">{{ _e('sac_lote_label') }}</span>
        <p class="sac-product-card__value">{{ props.model.lote }}</p>
      </div>
      <div class="sac-product-card__field col--wide col--md-6">
        <span class="sac-product-card__label">{{ _e('sac_data_label') }}</span>
        <p class="sac-product-card__value">{{ props.model.data }}</p>
      </div>

      <div class="sac-product-card__field col--wide">
        <span class="sac-product-card__label">{{ _e('sac_local_label') }}</span>
        <p class="sac-product-card__value">{{ props.model.local }}</p>
      </div>
      <div class="sac-product-card__field col--wide">
        <span class="sac-product-card__label">{{ _e('sac_desc_label') }}</span>
        <p class="sac-product-card__value">{{ props.model.desc }}</p>
      </div>
      <div class="sac-product-card__field col--wide">
        <span class="sac-product-card__label">{{ _e('sac_midia_review_label') }}</span>
        <p class="sac-product-card__value">{{ midiaList }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { _e } from '../../helpers/l10n';

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  exclude: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['edit', 'delete']);

const productName = computed(() => {
  const produtos = _e('sac_produtos_list');
  const produto = produtos.find((prod) => {
    return prod.id == props.model.produto
  });
  if(produto) {
    return produto.text;
  }

  return '';
});

const midiaList = computed(() => {
  if(props.model.midia && props.model.midia.length > 0) {
    let retorno = [];
    props.model.midia.map((f) => {
      retorno.push(f.name);
    });

    return retorno.join(', ');
  }

  return _e('sac_files_empty');
});

function handleEdit() {
  emit('edit', props.index);
}

function handleDelete() {
  emit('delete', props.index);
}
</script>
